import {Platform} from 'react-native';
import DeviceInfo from 'react-native-device-info';

export interface DeviceMetadata {
  device_type: string;
  device_model: string;
  device_os_version: string;
  app_version: string;
}

/** Collect non-persistent device metadata safe for audit notifications. */
export async function collectDeviceInfo(): Promise<DeviceMetadata> {
  let model = 'unknown';
  try {
    model = DeviceInfo.getModel();
  } catch {
    // Keep the fallback; device metadata must never block the user flow.
  }

  const osVersion =
    typeof Platform.Version === 'string'
      ? Platform.Version
      : String(Platform.Version);

  return {
    device_type: Platform.OS,
    device_model: model,
    device_os_version: `${Platform.OS} ${osVersion}`,
    app_version: `${DeviceInfo.getVersion()} (${DeviceInfo.getBuildNumber()})`,
  };
}
